/**
 *
 * @type {{bindToProductMedia: Function, displayModal: Function}}
 */
Modal = {

    /**
     *
     */
    bindToProductMedia: function () {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var productMedia = $('.product-media');
        productMedia.on("click", function (e) {
            e.preventDefault();
            $.ajax({
                type: "get",
                url: $(this).data("href")
            }).done( Modal.displayModal).fail(function () {
                console.error("Error Retrieving content from" + $(this).data("href"));
            });
        })
    },

    /**
     *
     * @param dataModal
     */
    displayModal: function (dataModal) {
        /**
         *
         */
        $('#ModalMedia .modal-body').html(dataModal);

        /**
         *
         * @type {string}
         */
        var modalId = "ModalMedia";

        /**
         *
         * @type {string}
         */
        var selectModal = '#' + modalId;
        //afficher la modal
        $(selectModal).show();
        $(selectModal).modal();
        /**
         * Ajout fonction sur l'event hide pour supprimer la modal
         */
        $(selectModal).on('hidden.bs.modal', function () {
            $(selectModal).hide();
        });
    },


    displayReparabilityModal: function (data) {
        var countRedirection = reparabilityRedirectMessage.match(/(?!={)\d+(?=})/g) != null
            ? reparabilityRedirectMessage.match(/(?!={)\d+(?=})/g)[0]
            : 2;
        var respContent = "";
        var timerId= 0;
        var modalId = "ModalMedia";
        var selectModal = '#' + modalId;

        $(selectModal).addClass("reparability-modal");

        timerId = setInterval(function () {
            $(selectModal).find(".modal-body").html( reparabilityRedirectMessage.replace(/{\d+}/g, countRedirection));
            if(countRedirection == 0) {
            	var url = (data.redirectionURL.match(/^https?:\/\//i) ? data.redirectionURL : 'http://' + data.redirectionURL);
                $("<a>").attr("href", url).attr("target", "_blank")[0].click();
                clearInterval(timerId);
            }
            countRedirection--;
        }, 1000);

        //afficher la modal
        $(selectModal).show();
        $(selectModal).modal();

        // Ajout fonction sur l'event hide pour supprimer la modal
        $(selectModal).on('hidden.bs.modal', function () {
            $(selectModal).hide();
        });
    }


};

/**
 *
 */
$(document).ready(function () {
    Modal.bindToProductMedia();
});
